// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import axios from '@configs/axios'

export const upgradeLevelOne = createAsyncThunk('KYC/upgradeLevelOne', async (data) => {
    return axios.post('/user/upgradeLevelOne', {data}, {headers:{"content-type": "multipart/form-data"}})
        .then(res => {
            console.log('KYC>>>>>', res)
            return {
                data: res.data
            }
        })
        .catch(err => {
            console.log(err)
            return {
                data: {}
            }
        })
})
export const upgradeLevelTwo = createAsyncThunk('KYC/upgradeLeveTwo', async (data) => {
    return axios.post('/user/upgradeLevelTwo', {data})
        .then(res => {
            return {
                data: res.data.data
            }
        })
        .catch(err => {
            return {
                data: {}
            }
        })
})
export const sendCode = createAsyncThunk('KYC/sendCode', async (data) => {
    axios.post('/user/getVerficiationCode', {data})
        .then(res => {
            return {
                data: res
            }
        })
        .catch(err => {
            return {
                data: {}
            }
        })
})
export const KYCSlice = createSlice({
    name: 'KYC',
    initialState: {
        statesData: {}
    },
    reducers: {
        handleFormOneLevel: (state, action) => {
            state.statesData = action.payload
        },
        handleFormTwoLevel: (state, action) => {
            state.statesData = action.payload
        }
    }
})

export const {handleFormOneLevel, handleFormTwoLevel} = KYCSlice.actions

export default KYCSlice.reducer
